import type React from 'react';
import { Helmet } from 'react-helmet';
import { BrowserRouter as Router } from 'react-router-dom';
import '@/App.css';
import { Account } from '@/Accounts';
import AppRoutes from '@/routes/AppRoutes';
import RoutePanelSync from '@/routes/RoutePanelSync';

/**
 * AppRouter
 * Centralizes all route definitions for the application.
 * Uses BrowserRouter to provide clean URLs (no hash): /home, /vessels, etc.
 */
const AppRouter: React.FC = () => {
  return (
    <Router>
      <Account>
        <div className="flex h-screen w-screen bg-black">
          <RoutePanelSync />
          <Helmet>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
            />
            <title>Space-Eyes SeaWatch</title>
          </Helmet>

          <AppRoutes />
        </div>
      </Account>
    </Router>
  );
};

export default AppRouter;
